<template>
    <div class="rp-helpdesk-conversation-message-text" :class="{'is-deleted': message.isDeleted}">
        
        <div
            v-html="text"
            v-linkified
            class="rp-helpdesk-conversation-message-text-box" />
        <attachments
            v-if="attachments && attachments.length > 0"
            :attachments="attachments"
            class="rp-helpdesk-conversation-message-attachments"
        />
    </div>
</template>

<script>
import Attachments from './Attachments'
import sanitizeHtml from 'sanitize-html';

export default {
    
    props: {

        message: {
            type: Object,
            required: true
        }

    },

    components: {
       Attachments, 
    },

    data() {
        return {
            htmlConfiguration: {
				allowedTags: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
				'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
				'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'iframe', 'img' ],
				allowedAttributes: {
					'*': ['href', 'name', 'target', 'style', 'width', 'height', 'align', 'height', 'cellspacing', 'cellpadding', 'src', 'colspan', 'rowspan', 'border', 'valign', 'bgcolor', 'rel' ],
				},
				transformTags: {
                    'a': sanitizeHtml.simpleTransform('a', {target: '_blank', rel: "noreferrer"})
                    // 'table': sanitizeHtml.simpleTransform('table', {width: '100%!important;'})
                },
            },
        }
    },

    computed: {
        
        text() {
            if(this.message.mediaValue) {
                let formattedMessage = this.message.mediaValue.split('\n').join('<br>')
                formattedMessage = sanitizeHtml(formattedMessage, this.htmlConfiguration);
                return formattedMessage;
            }
            return '';
        },

        attachments () {
            return this.message['attachments']
        },
        isAttachment () {
            if (this.message['attachments'] && this.message['attachments'].length) {
                return true
            }
            return false
        },
        
    }

}
</script>

<style lang="scss">

.rp-helpdesk-conversation-message-text {
    color: #4d4d4d;
    font-size: 14px;
    line-height: 1.4;
    display: flex;
    align-items: flex-start;
    
    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
    }
    &.is-deleted {
        font-style: italic;
        opacity: 0.6;
    }

    &.from-operator {
        flex-direction: column;
        .rp-helpdesk-conversation-message-sends-icon{
            margin-right: 5px;
            margin-bottom: 5px;
        }
        .rp-helpdesk-conversation-message-text-box {
            text-align: left;
            background: #f5f5f5;
            p {
                margin: 0;
            }
            .rp-helpdesk-conversation-message-attachments {
                margin-top: 15px;
                .attachment__item{
                    // font-size: 30px;
                    .attachment-wrapper{
                        .attachment-downloading-icon{
                            background-color: #fff;
                            border-radius: 2px;
                            box-shadow: 0px 1px 3px 1px #80808047;
                            color: #2661a9db;
                            padding: 11.5px 13px;
                            .attachment-downloading{
                                // font-size: 22px;
                            }
                        }
                    }
                }   
            }
        }
        a{
            color: $color !important;
        }
    }

    &.from-customer {
        flex-direction: column;
        align-items: flex-end;
        .rp-helpdesk-conversation-message-sends-icon{
            display:none;
        }
        .rp-helpdesk-conversation-message-text-box {
            text-align: left;
            background: var(--theme-background-color);
            color: #ffffff;
            a{
                color: #ffffff !important;
            }
        }
    }
    a {
	// color: #0000EE;
        font-weight: 500;
        &:hover{
            text-decoration: underline;
        }
    }
}

.rp-helpdesk-conversation-message-text-box {
	padding: 14px;
    border-radius: 5px;
    position: relative;
    display: inline-block;
    width: auto;
	max-width: 85%;
    font-size: 14px;
    @include for-size(desktop-up){
        font-size: 16px;
    }
    font-weight: 400;
    min-width: 80px;
    word-break: break-word;
}
</style>
